module.exports = __webpack_public_path__ + "static/media/punch-chowder-siteS.d4ad587c.gif";